import axios from "axios";

/**
 * Recherche des articles avec paramètres dynamiques.
 */
export const searchArticle = async ({
    q,
    idAff,
    dateMin,
    limit,
    offset
} = {}) => {
    try {
        const params = {};
        if (q) params.q = q;
        if (idAff) params.filter = `author.affiliations.id_aff = ${idAff}`;
        if (dateMin) params.filter = params.filter
            ? params.filter + ` AND date_pub_art > "${dateMin}"`
            : `date_pub_art > "${dateMin}"`;
        if (limit) params.limit = limit;
        if (offset) params.offset = offset;

        const url = `${process.env.REACT_APP_BASE_URL}/indexes/articles/search`;

        // Pour Create React App
        const token = process.env.REACT_APP_MEILI_SEARCH_TOKEN;
        if (!token) {
            console.error("[searchArticle] Token d'authentification manquant dans .env (REACT_APP_MEILI_SEARCH_TOKEN)");
            throw new Error("Le token d'authentification est requis dans .env (REACT_APP_MEILI_SEARCH_TOKEN)");
        }

        console.log("[searchArticle] Appel API avec paramètres :", params);

        const response = await axios.get(url, {
            params,
            headers: {
                accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
        });

        console.log("[searchArticle] Réponse reçue :", {
            status: response.status,
            data: response.data
        });

        return response.data;
    } catch (error) {
        if (error.response) {
            console.error("[searchArticle] Erreur réponse API :", {
                status: error.response.status,
                data: error.response.data
            });
        } else if (error.request) {
            console.error("[searchArticle] Aucune réponse reçue :", error.request);
        } else {
            console.error("[searchArticle] Erreur lors de la configuration de la requête :", error.message);
        }
        throw error;
    }
};